import gql from 'graphql-tag';

import { FRAGMENT_TEXT_ANNOTATIONS } from 'src/graphql/annotation/schema';
import { CUSTOMER_MEMBER_FRAGMENT } from 'src/graphql/customer/schema';
import { FRAGMENT_CONTENT_VALIDATION } from 'src/graphql/generation';
import { FRAGMENT_TARGET_AUDIENCE_INSIGHTS } from 'src/graphql/schema';

export const FRAGMENT_DOCUMENT_LINK = gql`
  fragment DocumentLink on DocumentLink {
    shareDocumentId
  }
`;

export const FRAGMENT_DOCUMENT_VIEW = gql`
  fragment DocumentView on DocumentView {
    id
    name
    editorContent
    editable
  }
`;

export const FRAGMENT_DOCUMENT_VARIATION_DETAILS = gql`
  fragment DocumentVariationDetails on SharedDocumentVariationDetailsView {
    scoring {
      score
      engagementScoreSupportSize
      ageScoreHistogram
      genderScoreHistogram
      language
    }
    annotations {
      ...TextAnnotations
    }
    validations {
      ...ContentValidation
    }
    targetAudienceInsights {
      ...TargetAudienceInsights
    }
  }
  ${FRAGMENT_CONTENT_VALIDATION}
  ${FRAGMENT_TEXT_ANNOTATIONS}
  ${FRAGMENT_TARGET_AUDIENCE_INSIGHTS}
`;

export const FRAGMENT_PROJECT_REVIEWERS = gql`
  fragment ProjectReviewers on Project {
    id
    reviewers {
      ...CustomerMember
    }
  }
  ${CUSTOMER_MEMBER_FRAGMENT}
`;
